import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana21Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
   
   <rect width="1221" height="921" fill="url(#pattern0_1467_38255)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M752.769 320.783L728.031 375.56L696.413 381.14L679.674 310.465L731.751 297.445C748.785 294.825 753.607 306.436 754.092 314.75C754.213 316.836 753.629 318.878 752.769 320.783Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("21"))}      
      d="M690.833 459.256L728.031 375.562C702.736 380.025 660.455 391.06 642.477 396.02L664.795 466.695L690.833 459.256Z" 
      fill={getFillByLot(21, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("2"))}      
      d="M622.018 327.2L679.674 310.461L696.413 381.136L642.476 396.015L622.018 327.2Z" 
      fill={getFillByLot(2, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("3"))}      
      d="M566.224 347.662L622.02 327.203L642.479 396.018L588.543 416.477L566.224 347.662Z" 
      fill={getFillByLot(3, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("20"))}      
      d="M612.716 487.151L664.793 466.693L642.474 396.018L584.818 418.336L612.716 487.151Z" 
      fill={getFillByLot(20, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("19"))}      
      d="M560.645 509.47L612.721 487.151L584.823 418.336L529.027 440.654L560.645 509.47Z" 
      fill={getFillByLot(19, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("4"))}      
      d="M510.424 369.978L566.22 347.659L588.539 416.475L538.322 436.933L510.424 369.978Z" 
      fill={getFillByLot(4, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("5"))}      
      d="M456.488 396.019L510.424 369.98L538.322 436.936L488.106 461.114L456.488 396.019Z" 
      fill={getFillByLot(5, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("18"))}      
      d="M508.562 535.511L560.639 509.473L529.021 440.657L473.225 468.555L508.562 535.511Z" 
      fill={getFillByLot(18, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("6"))}      
      d="M404.414 422.056L456.491 396.018L488.108 461.113L437.892 487.151L404.414 422.056Z" 
      fill={getFillByLot(6, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("17"))}      
      d="M456.486 563.404L508.562 535.506L473.225 468.551L421.148 496.449L456.486 563.404Z" 
      fill={getFillByLot(17, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("7"))}      
      d="M352.338 449.956L404.414 422.058L437.892 487.153L383.956 516.911L352.338 449.956Z" 
      fill={getFillByLot(7, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("16"))}      
      d="M402.551 591.304L456.488 563.406L421.15 496.45L367.214 526.208L402.551 591.304Z" 
      fill={getFillByLot(16, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("15"))}      
      d="M348.613 619.203L402.55 591.305L367.212 526.209L315.136 552.247L348.613 619.203Z" 
      fill={getFillByLot(15, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("8"))}      
      d="M302.123 475.991L352.34 449.953L383.957 516.909L333.741 542.947L302.123 475.991Z" 
      fill={getFillByLot(8, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("9"))}      
      d="M251.902 500.172L302.119 475.993L333.737 542.949L281.66 568.987L251.902 500.172Z" 
      fill={getFillByLot(9, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("14"))}      
      d="M294.679 645.24L348.616 619.202L315.138 552.246L263.062 578.284L294.679 645.24Z" 
      fill={getFillByLot(14, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("13"))}      
      d="M238.883 669.421L294.68 645.243L263.062 578.287L210.985 600.606L238.883 669.421Z" 
      fill={getFillByLot(13, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("10"))}      
      d="M201.688 524.35L251.905 500.172L281.663 568.987L229.587 593.166L201.688 524.35Z" 
      fill={getFillByLot(10, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("11"))}      
      d="M158.907 542.951L201.684 524.353L229.582 593.168L164.487 619.206L158.907 542.951Z" 
      fill={getFillByLot(11, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("12"))}      
      d="M170.064 684.299L164.484 619.203L210.981 600.604L238.879 669.42L184.943 691.738C177.503 693.226 171.924 687.399 170.064 684.299Z" 
      fill={getFillByLot(12, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1467_38255" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1467_38255" transform="matrix(0.00255113 0 0 0.00338211 -4.90263 -1.70932)"/>
    </pattern>
    <image id="image0_1467_38255"  width="4096" height="2304" href="/mz2.png"/>
    </defs>
  </svg>
  );
};